import * as TyreOrderModels from '../../models/tyre-order/tyre-order';
import { TyreOrderSearchModel } from '../../models/tyre-order/tyre-orderSearch';
import * as Models from '../../models/commonModels';


export class GetList {
  static readonly type = '[TyreOrder] List';
  constructor(public Search: TyreOrderSearchModel) { }
}

export class SetSearch {
  static readonly type = '[TyreOrder] Set Search';
  constructor(public Search: TyreOrderSearchModel) { }
}

export class ResetSearch {
  static readonly type = '[TyreOrder] Reset Search';
  constructor() { }
}

export class SetListPage {
  static readonly type = '[TyreOrder] Set List Page';
  constructor(public Search: TyreOrderSearchModel) { }
}

export class Create {
  static readonly type = '[TyreOrder] Create';
  constructor(public Order: Models.Request<TyreOrderModels.TyreOrderCreateModel>) { }
}

export class Set {
  static readonly type = '[TyreOrder] Set';
  constructor(public Order: Models.Request<TyreOrderModels.TyreOrderModel>) { }
}

export class Get {
  static readonly type = '[TyreOrder] Get';
  constructor(public OrderId: Models.RequestModel) { }
}

export class GetStatusDictionary {
  static readonly type = '[TyreOrder] Get Status Dictionary';
  constructor() { }
}

// this action state is responsible for clear the upload form,
export class SetImportStatus {
  static readonly type = '[TyreOrder] SetImportStatus';
  constructor(public Status: boolean) { }
}

export class Import {
  static readonly type = '[TyreOrder] Import';
  constructor(public FileName: string, public Data: any) { }
}

export class GetFilteredReport {
  static readonly type = '[TyreOrder] GetFilteredReport';
  constructor(public Search: TyreOrderSearchModel) { }
}

export class DisposeSearch {
  static readonly type = '[TyreOrder] DisposeSearch';
  constructor() { }
}

export class ImportLatexDelivery {
  static readonly type = '[Car] ImportLatexDelivery';
  constructor(public File: File) { }
}
